import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MediaQuery from 'react-responsive';
import cn from 'classnames';
import { useTheme } from '@websky/core/src/theme';
import { MOBILE_MIN_WIDTH } from '@websky/core/src/utils';
import { PaymentType } from '@websky/core/src/PaymentForm/types';
import Iframe from '@websky/core/src/PaymentForm/components/Gateway/Iframe/Iframe';
import theme from './PaymentFormCards.css';
const sbp = require('../../theme/images/sbp.svg');
const PaymentFormMethods = ({ fps, successURL, failURL }) => {
    const { PaymentForm: css } = useTheme('PaymentForm');
    const { t } = useTranslation('PaymentForm');
    const [page, setPage] = useState(null);
    return (React.createElement(React.Fragment, null, fps && (React.createElement(React.Fragment, null, (page === null || page === void 0 ? void 0 : page.content) ? (React.createElement("div", { className: theme.iframe }, page.content)) : (React.createElement(MediaQuery, { minWidth: MOBILE_MIN_WIDTH },
        React.createElement(Iframe, { successURL: successURL, failURL: failURL, type: PaymentType.Fps, isPreOpened: true, frameInfo: fps, onClick: setPage, headerTitle: t('Fast payment system'), gatewayTitle: t('Fast payment system'), variant: "iframe" },
            React.createElement("div", { className: css.cards },
                React.createElement("img", { src: sbp, alt: "SBP", className: cn(css.card, theme.fps) })))))))));
};
export default PaymentFormMethods;
